import { productPhotoMetadata } from '@iheartjane/menu';
import { Button, Flex, Image, Typography } from '@iheartjane/reefer';

import type { WeightSelectorWeight } from '@jane/shared-ecomm/types';

import { useProductCardContext } from '../productCardProvider';
import { potencyInfo } from '../productPotency/productPotency';
import { WeightButton } from './weightButton';

import styles from './selectWeightForm.module.css';

interface SelectWeightFormProps {
  onAddToCartPressed: () => void;
  weights: WeightSelectorWeight[];
}

export const SelectWeightForm = ({
  weights,
  onAddToCartPressed,
}: SelectWeightFormProps) => {
  const { menuProduct: product, selectedWeight } = useProductCardContext();

  const { url } = productPhotoMetadata(product);

  if (!product) return null;

  return (
    <>
      <div className={styles['productDetailsContainer']}>
        <Image
          src={url || ''}
          height="96px"
          width="96px"
          altText={product?.name || ''}
        />
        <div>
          <Typography color="text-main" variant="body-semibold">
            {product?.name}
          </Typography>
          <Typography color="grays-mid">
            {product?.brand} {product?.root_subtype}
          </Typography>
          <Typography color="grays-mid">
            {potencyInfo(product, selectedWeight)}
          </Typography>
        </div>
      </div>

      <Typography color="text-main" variant="body-semibold" mt={40} mb={16}>
        Select weight
      </Typography>
      <Flex flexWrap="wrap" gap={16}>
        {weights.map((weight) => (
          <WeightButton key={weight.value} weight={weight} />
        ))}
      </Flex>
      <Button label="Add to bag" full onClick={onAddToCartPressed} mt={16} />
    </>
  );
};
